class BeaconController {
  /* @ngInject */
  constructor(BeaconService) {
    const that = this;
    that.reason = '';
    that.comments = '';
    that.beaconObj = {
      reason: ''
    };
    that.dialogTitle = 'Titolone';
    that.dialogTest = 'un bel testo!';

    that.reasonChoiches = [
     { label: 'Assistenza', value: 0 },
     { label: 'Guasti', value: 1 },
     { label: 'Richiesta nuovo beacon', value: 2 },
     { label: 'Sostituzioni', value: 3 },
     { label: 'altro', value: 4 }
    ];

    that.sendBeaconRequest = () => {
      BeaconService.sendBeaconRequest(that.reason, that.comments);
    };
  }
}

export default BeaconController;



/** WEBPACK FOOTER **
 ** ./client/app/components/shop/beacon/beacon.controller.js
 **/